import { Arrays } from "@opendaw/lib-std";
import { AbstractModuleAdapter } from "../abstract";
import { Direction, ModuleConnectorAdapter } from "../connector";
export class ModularAudioInputAdapter extends AbstractModuleAdapter {
    #voltageOutput;
    constructor(context, box) {
        super(context, box);
        this.#voltageOutput = ModuleConnectorAdapter.create(context.boxAdapters, box.output, Direction.Output, "Output");
    }
    get voltageOutput() { return this.#voltageOutput; }
    get inputs() {
        return Arrays.empty();
    }
    get outputs() {
        return [this.#voltageOutput];
    }
}
